(function () {
  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  onReady(() => {
    const overlay = document.getElementById("authOverlay");
    const modal = document.querySelector("#authOverlay .authModal");

    if (!overlay || !modal) {
      console.error("[Auth] Missing #authOverlay or .authModal in DOM.");
      return;
    }

    // Show/Hide helpers
    function showAuth() {
      overlay.removeAttribute("hidden"); // remove UA display:none
      overlay.setAttribute("open", ""); // trigger CSS [open] display
      // Optional: focus the first focusable element inside
      (
        modal.querySelector(
          "button, input, select, textarea, [href], [tabindex]:not([tabindex='-1'])"
        ) || modal
      )?.focus?.();
    }
    function hideAuth() {
      overlay.setAttribute("hidden", ""); // return to hidden state
      overlay.removeAttribute("open");
    }

    // Bind to #openSignIn if present now…
    const openBtn = document.getElementById("openSignIn");
    if (openBtn) {
      openBtn.addEventListener("click", (e) => {
        e.preventDefault();
        showAuth();
      });
    }

    // …and also via event delegation in case #openSignIn is added later
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest("#openSignIn");
      if (trigger) {
        e.preventDefault();
        showAuth();
      }
    });

    // Close buttons
    document.querySelectorAll("[data-auth-close]").forEach((btn) => {
      btn.addEventListener("click", hideAuth);
    });

    // ESC to close
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && overlay.hasAttribute("open")) hideAuth();
    });

    // Click outside to close
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) hideAuth();
    });
    // Prevent overlay-close when clicking inside the modal
    modal.addEventListener("click", (e) => e.stopPropagation());

    // -------- Mock OTP flow (same as before) --------
    const step1 = document.getElementById("phoneStep1");
    const step2 = document.getElementById("phoneStep2");
    const capture = document.getElementById("profileCapture");

    document.querySelector("[data-send-otp]")?.addEventListener("click", () => {
      step1?.classList.add("is-hidden");
      step2?.classList.remove("is-hidden");
    });

    document
      .querySelector("[data-verify-otp]")
      ?.addEventListener("click", () => {
        const isNew = true; // replace with API response
        step2?.classList.add("is-hidden");
        if (isNew) {
          capture?.classList.remove("is-hidden");
        } else {
          hideAuth();
        }
      });

    document
      .querySelector("[data-resend-otp]")
      ?.addEventListener("click", () => {
        alert("OTP resent");
      });
  });
})();
